var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#757576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11ZM15.2308 6.34615C15.2308 8.68274 13.3366 10.5769 11 10.5769C8.66341 10.5769 6.76923 8.68274 6.76923 6.34615C6.76923 4.00956 8.66341 2.11538 11 2.11538C13.3366 2.11538 15.2308 4.00956 15.2308 6.34615ZM11 19.8846C14.5341 19.8846 17.399 18.8366 17.399 16.5C17.399 14.1634 14.5341 12.2692 11 12.2692C7.46591 12.2692 4.60096 14.1634 4.60096 16.5C4.60096 18.8366 7.46591 19.8846 11 19.8846Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.7209b18901ec711c4c21ab9972df612a.svg";
export { ForwardRef as ReactComponent };